import { createSelector } from '@reduxjs/toolkit'
import { TRootState } from 'store/types'

const selector = (state: TRootState) => state.user

const data = createSelector(selector, state => state.data)

const isLoading = createSelector(selector, state => state.isLoading)

const isUserLoggedIn = createSelector(selector, state => !!state.data.id)

const activeHighestSubscription = createSelector(
  selector,
  state => state.activeHighestSubscription.data
)

const activeHighestSubscriptionIsLoading = createSelector(
  selector,
  state => state.activeHighestSubscription.isLoading
)

const isFreeUser = createSelector(
  selector,
  state => !(state.data.hdMax && state.data.hdMax > 0)
)

const userId = createSelector(selector, state => state.data.id)

const userStats = createSelector(selector, state => state.userStats)

const userStorageUsageSize = createSelector(
  userStats,
  userStats => userStats?.usage.size
)

const userStorageLimitSize = createSelector(
  userStats,
  userStats => userStats?.limit.size
)

const freeStorageSize = createSelector(
  [userStats, userStorageUsageSize, userStorageLimitSize],
  (
    userStats,
    userStorageUsageSize?: number,
    userStorageLimitSize?: number
  ): number | null => {
    if (
      userStats &&
      userStats.usage &&
      userStats.limit &&
      userStorageUsageSize !== undefined &&
      userStorageLimitSize !== undefined
    ) {
      return userStorageLimitSize - userStorageUsageSize
    }
    return null
  }
)

const isStorageFull = createSelector(
  [freeStorageSize],
  (freeStorage): boolean => {
    return freeStorage !== null && freeStorage <= 0
  }
)

const userCurrentPlanId = createSelector(
  selector,
  state => state.userCurrentTariffId
)

const unlimitedAiImageModelIds = createSelector(
  selector,
  state => state.unlimitedAiImageModelIds
)

const unlimitedAiVideoModels = createSelector(
  selector,
  state => state.unlimitedAiVideoModels
)

export const userSelectors = {
  data,
  isLoading,
  isUserLoggedIn,
  activeHighestSubscription,
  activeHighestSubscriptionIsLoading,
  isFreeUser,
  userId,
  userStats,
  userStorageUsageSize,
  userStorageLimitSize,
  isStorageFull,
  freeStorageSize,
  userCurrentPlanId,
  unlimitedAiImageModelIds,
  unlimitedAiVideoModels
}
